import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="football.id" />
      <TextField source="football.passingCompletions" />
      <TextField source="football.passingAttempts" />
      <TextField source="football.passingYards" />
      <TextField source="football.passingTouchdowns" />
      <TextField source="football.passingInterceptions" />
      <TextField source="football.passingCompletionPercentage" />
      <TextField source="football.rushingAttempts" />
      <TextField source="football.rushingYards" />
      <TextField source="football.rushingTouchdowns" />
      <TextField source="football.rushingAverage" />
      <TextField source="football.receptions" />
      <TextField source="football.receivingYards" />
      <TextField source="football.receivingTouchdowns" />
      <TextField source="football.receivingAverage" />
      <TextField source="football.totalPoints" />
    </SimpleShowLayout>
  );
};

export default Tab;
